var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8921 11.9999C19.8921 12.4141 19.5563 12.7499 19.1421 12.7499H4.99998C4.58576 12.7499 4.24998 12.4141 4.24998 11.9999C4.24998 11.5857 4.58576 11.2499 4.99998 11.2499H19.1421C19.5563 11.2499 19.8921 11.5857 19.8921 11.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputMinus);
export default __webpack_public_path__ + "static/media/input-minus.01165985.svg";
export { ForwardRef as ReactComponent };